import styled from 'styled-components';
import { Box } from '@rsos/components/capstone/base';

export const ShapeFilesDetailsTable = styled.table`
  position: relative;
  display: grid;
  border-collapse: collapse;
  min-width: 100%;
  grid-template-columns: 2fr 1.67fr 1.67fr 1fr;
`;

export const ShapeFilesDetailsTableHead = styled.thead`
  display: contents;
`;
export const ShapeFilesDetailsTableBody = styled.tbody`
  display: contents;
`;
export const ShapeFilesDetailsTableTR = styled.tr`
  display: contents;
`;
export const ShapeFilesDetailsTableTD = styled.td`
  display: flex;
  align-items: center;
  padding: 10px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 14px;
  color: ${({ theme }) => theme.colors.primaryText};
`;
export const ShapeFilesDetailsTableTH = styled.th`
  padding: 15px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  position: sticky;
  top: 0;
  text-align: left;
  font-weight: bold;
  font-size: 10px;
  color: ${({ theme }) => theme.colors.primaryText};
`;

export const NameContainer = styled(Box)`
  max-width: 175px;
`;
